import { DatesApiResponse } from '@blk/aw-bff-typescript-models';
import { AxiosResponse } from 'axios';
import { awBffApi } from './Base';

interface GetDatesParams {
  pkg: string;
}

export const datesPath = '/dates';
export function getAvailableDates(params: GetDatesParams): Promise<AxiosResponse<DatesApiResponse>> {
  return awBffApi.get<DatesApiResponse>(datesPath, { params });
}

export interface GetDateParams {
  /**
   * 'AW_DEMO_B'
   */
  pkg: string;
  /**
   * 'YYYY-MM-DD'
   */
  baseDate: string;
  /**
   * 'BD-1' - subtracts one business day from the base date
   * 'M3' - returns month end of base date
   * 'Y+1' - adds one year to the base date
   */
  dateCalcExpression: string;
}

export function getDate(params: GetDateParams): Promise<AxiosResponse<string>> {
  const path = '/dates/evaluate';

  return awBffApi.get<string>(path, { params });
}

/**
 * Type ValidDate from the API is not captured in the TS interfaces that are exported.
 */
export interface SerializedValidDate {
  date: string;
  released: boolean;
}

export interface GetLastXBusinessDaysParams {
  /**
   * 'YYYY-MM-DD'
   */
  baseDate: string;
  /**
   * number of business days
   */
  days: number;
}

export function getLastXBusinessDays(params: GetLastXBusinessDaysParams): Promise<AxiosResponse<string[]>> {
  const path = '/dates/lastXBusinessDays';
  return awBffApi.get<string[]>(path, { params });
}
